import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function O2Section(props) {
  var children = props.children,
      className = props.className,
      separate = props.separate,
      standalone = props.standalone,
      top = props.top,
      bottom = props.bottom,
      outdent = props.outdent,
      attributes = _objectWithoutPropertiesLoose(props, ["children", "className", "separate", "standalone", "top", "bottom", "outdent"]);

  var classes = classNames(className, 'o2-section', top ? "o2-section--" + top + "-top" : false, bottom ? "o2-section--" + bottom + "-bottom" : false, {
    'o2-section--separate': separate,
    'o2-section--standalone': standalone
  });

  if (outdent) {
    return /*#__PURE__*/React.createElement("div", _extends({}, attributes, {
      className: classes
    }), /*#__PURE__*/React.createElement("div", {
      className: "o2-section__outdent"
    }, children));
  }

  return /*#__PURE__*/React.createElement("div", _extends({}, attributes, {
    className: classes
  }), children);
}

O2Section.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  separate: PropTypes.bool,
  standalone: PropTypes.bool,
  top: PropTypes.oneOf(['separate', 'standalone', 'join']),
  bottom: PropTypes.oneOf(['separate', 'standalone', 'join']),
  outdent: PropTypes.bool
};
export default O2Section;